// extracted by mini-css-extract-plugin
module.exports = {"avatar":"e_zy","fallback":"e_Ay","s40":"e_By","s32":"e_Cy"};